(function () {
  'use strict';

  var HASH = '#product-request-form';

  function getQuoteForm() {
    return document.getElementById('product-request-form');
  }

  function openQuoteForm() {
    var form = getQuoteForm();
    if (!form) return false;

    var details = form.querySelector('.product-request-form__disclosure');
    if (details) {
      details.setAttribute('open', '');
      details.open = true;
    }

    form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return true;
  }

  function openQuoteFormWhenReady() {
    if (openQuoteForm()) return;

    // Form may render slightly later (section hydration)
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (openQuoteForm() || tries >= 20) {
        window.clearInterval(timer);
      }
    }, 50);
  }

  function shouldOpenFromHash() {
    return window.location.hash === HASH;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vatpan-quote-cta]');
    if (!btn) return;

    if (!getQuoteForm()) return;

    e.preventDefault();
    openQuoteFormWhenReady();

    if (window.history && window.history.replaceState) {
      try {
        window.history.replaceState(null, '', HASH);
      } catch (err) {
        // ignore
      }
    }
  });

  window.addEventListener('hashchange', function () {
    if (shouldOpenFromHash()) openQuoteFormWhenReady();
  });

  window.addEventListener('pageshow', function () {
    if (shouldOpenFromHash()) openQuoteFormWhenReady();
  });

  function initQuoteHash() {
    if (!shouldOpenFromHash()) return;
    openQuoteFormWhenReady();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuoteHash);
  } else {
    initQuoteHash();
  }
})();
